<template>
  <v-sheet height="400px">
    <v-layout justify-center="justify-center">
      <div class="text-center" :style="bottomSheetWidth">
        <div class="d-flex">
          <v-btn
            class="mt-4"
            text="text"
            large="large"
            color="grey darken-2"
            @click="onCancelAction"
            >{{ cancelActionTextComputed }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="mt-4"
            text="text"
            large="large"
            color="primary"
            @click="onConfirmAction"
            >{{ confirmActionTextComputed }}</v-btn
          >
        </div>
        <div class="pa-3" v-if="$store.getters.appBottomSheet">
          <v-text-field
            :hint="hintComputed"
            :label="label"
            :placeholder="placeholder"
            value="0,00"
            disabled="disabled"
            style="font-size: 22px"
            v-if="notChange"
          ></v-text-field>
          <v-text-field
            :hint="hintComputed"
            :label="label"
            :placeholder="placeholder"
            @keypress.enter="onConfirmAction"
            color="primary"
            ref="input"
            style="font-size: 22px"
            type="tel"
            v-currency="currencyOptions"
            v-model="value"
            v-else
          ></v-text-field>
          <v-checkbox
            :label="$t('store.checkout.not_change')"
            color="primary"
            hide-details="hide-details"
            v-model="notChange"
          ></v-checkbox>
        </div>
      </div>
    </v-layout>
  </v-sheet>
</template>

<script>
import { defineComponent } from "vue";
import { parseCurrency } from "vue-currency-input";

export default defineComponent({
  name: "app-input-alert-change",
  props: ["options"],

  data() {
    return {
      cancelAction: {},
      confirmAction: {},
      label: "",
      placeholder: "",
      value: "",
      total: 0,
      timeout: -1,
      notChange: false,
    };
  },

  mounted() {
    this.handleOptions(this.options);
  },

  computed: {
    bottomSheetWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          return "width: 650px;";
        default:
          return "width: 550px;";
      }
    },

    cancelActionTextComputed() {
      return this.cancelAction.t
        ? this.$t(this.cancelAction.t)
        : this.cancelAction.text;
    },

    confirmActionTextComputed() {
      return this.confirmAction.t
        ? this.$t(this.confirmAction.t)
        : this.confirmAction.text;
    },

    currencyOptions() {
      return {
        autoDecimalMode: true,
        currency: null,
        precision: 2,
      };
    },

    hintComputed() {
      if (this.total && this.value) {
        const formatted = this.value?.toString?.();
        const options = this.currencyOptions;
        const change = parseCurrency(formatted, options) - this.total;
        return `Total do pedido: ${this.$utils.BRL(
          this.total
        )}, Troco: ${this.$utils.BRL(change)}`;
      }
      return `Total do pedido: ${this.$utils.BRL(this.total)}`;
    },
  },

  watch: {
    options(v) {
      this.handleOptions(v);
    },
  },

  methods: {
    handleOptions(v) {
      if (v?.actions?.length) {
        const [cancel, confirm] = v.actions;
        this.confirmAction = confirm ?? cancel ?? { t: "alert.button.confirm" };
        const cnc = confirm && cancel;
        this.cancelAction = cnc ? cancel : { t: "alert.button.cancel" };
      }
      if (v?.value) {
        const next = v?.value === -1 ? 0 : v?.value;
        if (typeof next === "string") {
          this.value = parseCurrency(next, this.currencyOptions);
        } else if (typeof next === "number") {
          this.value = next;
        }
        this.notChange = v?.value === -1;
      }
      this.total = v?.total || 0;
      this.label = v?.label;
      this.placeholder = v?.placeholder;

      setTimeout(() => {
        this.$refs?.input?.focus?.();
      }, 500);
    },

    onCancelAction() {
      this.cancelAction?.onPress?.();
      this.$nextTick(() => {
        this.$inputAlertChange.dismiss();
      });
    },

    onConfirmAction() {
      if (this.confirmAction.onPress) {
        const value = this.notChange
          ? -1
          : parseCurrency(this.value?.toString?.(), this.currencyOptions);
        this.confirmAction.onPress(value);
      }
      this.$nextTick(() => {
        this.$inputAlertChange.dismiss();
      });
    },
  },
});
</script>
